import { computed, signal } from '@angular/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { clamp, floor } from 'lodash-es';

export class Progress {
  private readonly _mode = signal<ProgressBarMode>('indeterminate');
  private readonly _loaded = signal(0);
  private readonly _total = signal(0);

  public readonly mode = this._mode.asReadonly();
  public readonly loaded = this._loaded.asReadonly();
  public readonly total = this._total.asReadonly();

  public readonly percentage = computed(() =>
    this._total() > 0 ? floor((this._loaded() / this._total()) * 100) : 0
  );

  setProgress(progress: number) {
    this._loaded.set(clamp(progress, 0, this._total()));
  }

  setMode(mode: ProgressBarMode) {
    this._mode.set(mode);
  }

  setTotal(total: number) {
    this._total.set(total);
  }
}
